import React from 'react'
import styled from 'styled-components'

import { Avatar } from 'src/components/ui/Avatar'
import { Text } from 'src/components/ui/Text'
import { themeEstra } from 'src/styles/themeEstra'

interface Props {
  avatarUrl: string
  tagline: string
  personName: string
  role: string
  link?: string
  openInNewTab?: boolean
  spacerTop?: number
  className?: string
}

export const CardPerson: React.FC<Props> = ({
  avatarUrl,
  tagline,
  personName,
  role,
  link,
  openInNewTab,
  spacerTop,
  className,
}) => {
  return (
    <CardLink
      href={link || '#'}
      mt={spacerTop}
      className={className}
      rel='noopener noreferrer'
      target={openInNewTab ? '_blank' : undefined}
    >
      <Wrapper>
        <CardAvatar
          src={avatarUrl}
          mobileSize={50}
          size={76}
          fluid
          shadow
          border
        />
        <CardText>
          <div>{tagline}</div>
          <strong>{personName}</strong>
          <em>{role}</em>
        </CardText>
        <Arrow>
          <svg
            width='15'
            height='46'
            viewBox='0 0 15 46'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M1 1L13 22.5686L1 45'
              stroke='#0E1A2F'
              strokeWidth='2'
              strokeLinecap='round'
            />
          </svg>
        </Arrow>
      </Wrapper>
    </CardLink>
  )
}

interface CardLinkProps {
  mt?: number
}

const CardLink = styled.a<CardLinkProps>`
  display: flex;
  margin-top: ${({ mt }) => (mt ? `${mt}rem` : 0)};
  &:hover {
    opacity: 1;
  }
`

const CardText = styled(Text)`
  color: ${themeEstra.color.primari.grigioEstra};
  padding-left: 0.5rem;
  padding-right: 2.5rem;
  font-size: 0.875rem;
  strong,
  b {
    display: block;
    color: ${themeEstra.color.primari.neroEstra};
    font-size: 1rem;
  }
`

const Wrapper = styled.div`
  max-width: 310px;
  text-align: left;
  background-color: ${themeEstra.color.neutri.grigioBg};
  display: flex;
  padding: 1.25rem 1.5rem;
  border-radius: 20px;
  align-items: center;
  transition: background-color 0.3s;
  margin: 0 auto;
  @media (min-width: ${themeEstra.bp.tablet}) {
    max-width: 400px;
  }
  @media (min-width: ${themeEstra.bp.desktop}) {
    flex-wrap: nowrap;
    margin: 0;
  }

  &:hover {
    background-color: ${themeEstra.color.primari.ciano};

    ${CardText} {
      color: #fff;
      strong,
      b {
        color: #fff;
      }
    }
  }
`

const CardAvatar = styled(Avatar)`
  margin-left: -50px;
  @media (min-width: ${themeEstra.bp.tablet}) {
    margin-left: 0;
  }
`

const Arrow = styled.div`
  margin-left: auto;
`
